import { Nav, Navbar } from 'reactstrap';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';
import { useCallback, useMemo } from 'react';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import { paradigmLightBlue } from '@paradigm/design-system/src/colors';
import { TabContainer, Tab } from '#/components/Leaderboard/shared/components';
import MobileTabHeader from '#/components/Leaderboard/shared/MobileTabHeader';
import {
  TabId,
  useLeaderboardTabsActions,
  useLeaderboardTabsView,
} from '@paradigm/features/src/leaderboard/contexts/tabs';
import { useLiquidityFilterState } from '@paradigm/features/src/leaderboard/contexts/liquidity-filter';
import LiquidityFillsTab from '#/components/Leaderboard/liquidity/LiquidityFillsTab';
import LiquidityResponsesTab from '#/components/Leaderboard/liquidity/LiquidityResponsesTab';
import LiquidityMobileMenuSection from '#/components/Leaderboard/liquidity/LiquidityMobileMenuSection';

type LiquidityTab = 'fills' | 'responses';

export default function LeaderboardLiquidityTab() {
  const { activeTab: tab } = useLeaderboardTabsView();
  const { setActiveTab } = useLeaderboardTabsActions();
  const filterState = useLiquidityFilterState();

  const liquidityTab = useMemo(() => tab.replace('liquidity-', ''), [tab]);
  const setLiquidityTab = useCallback(
    (newTab: string) => setActiveTab(`liquidity-${newTab}` as TabId),
    [setActiveTab],
  );

  return (
    <>
      <MediaQuery maxWidth={MOBILE_BREAKPOINT}>
        <MobileTabHeader filterState={filterState} />
        <LiquidityMobileMenuSection
          value={liquidityTab}
          onChange={setLiquidityTab}
        />
      </MediaQuery>
      <MediaQuery minWidth={MOBILE_BREAKPOINT}>
        <LiquididyTabContainer>
          <Header>
            <Nav css="margin: 0;" role="tablist">
              <LiquidityTab
                tabId="liquidity-fills"
                label="Leaderboard Liquidity Fills Tab"
              >
                Fills
              </LiquidityTab>
              <LiquidityTab
                tabId="liquidity-responses"
                label="Leaderboard Liquidity Responses Tab"
              >
                Responses
              </LiquidityTab>
            </Nav>
          </Header>
          <Divider />
        </LiquididyTabContainer>
      </MediaQuery>
      {tab === 'liquidity-fills' && <LiquidityFillsTab />}
      {tab === 'liquidity-responses' && <LiquidityResponsesTab />}
    </>
  );
}

const LiquididyTabContainer = styled(TabContainer)`
  margin: 0;
`;

const LiquidityTab = styled(Tab)`
  margin: 0;

  &:first-child {
    margin-left: 35px;
    margin-right: 20px;
  }
`;

const Divider = styled.div`
  box-sizing: border-box;
  height: 1px;
  border-radius: 2px;
  border: 2px solid ${paradigmLightBlue};
  opacity: 0.1;
  margin: 0 2rem;
  margin-top: -3px;
  margin-bottom: 15px;
`;

const Header = styled(Navbar)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  padding: 0;
  margin: 0 8px;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    grid-template-columns: 1fr auto;
    padding: 0;
    z-index: 1000;
    margin-bottom: -3px;
    > ul {
      margin: auto;
      width: 100%;
      justify-content: center;
    }
  }
`;
